import React from "react";
import { Helmet } from "react-helmet-async";
import './Hero.css'
import ActionButton from "../actionbutton/ActionButton";
import HomeImage from '../../assets/images/website/home.jpg'


const Hero =()=>{
    return(
      <>
             <Helmet>
    <title> RoshTech</title>
    <meta name="description" content="Innovating Software Solutions for a Digital Future" />
   
</Helmet>
      <section className="hero-section">

          <div className="hero-content">
            <div className="text">
            <h1>Building Africa’s Digital Future, One Innovation at a Time</h1>
            <p>At RoshTech, we craft innovative, market-driven software tailored to Africa’s unique challenges — from FinTech to business and community systems. Scalable, sustainable, and future-ready.</p>
            <ActionButton prop="Discover Our Solutions" className="action-btn"/>

            </div>
            <div className="hero-image">
            <img src={HomeImage} alt="Illustration of digital solutions in Africa" width="100%" height="70%"/>
            </div>
          </div>

           
               
           
            

            

    
            
         
           
          </section>
      </>
    )
}

export default Hero;
